const user = {
  state: sessionStorage.getItem('userState') ? JSON.parse(sessionStorage.getItem('userState')) : {
    user: {
      username: '',
      name: '',
      id: '',
      token: '',
      perms: [],    //用户所有权限标识列表
      menuList: [],   //用户所有菜单的列表
      tabList: [],    //tab标签数组的列表
      currentTab: '',    //当前激活的tab页
      mainPagePath: '',    //首页的url,首页不允许删除
      routerParams: {}    //路由跳转时的参数,点击tab页时需要
    }
  },
  getters: {
    getUser(state) {
      return state.user
    }
  },
  mutations: {
    updateUser(state, user) {
      state.user = user
    },
    updatePerms(state, perms) {
      state.user.perms = perms
    },
    updateMenuList(state, menuList) {
      state.user.menuList = menuList
    },
    updateTabList(state, tabList) {
      state.user.tabList = tabList
    },
    updateCurrentTab(state, currentTab) {
      state.user.currentTab = currentTab
    },
    updateMainPagePath(state, mainPagePath) {
      state.user.mainPagePath = mainPagePath
    },
    updateRouterParams(state, routerParams) {
      state.user.routerParams = routerParams
    }
  },
  actions: {
    asyncUpdateUser(context, user) {
      context.commit('updateUser', user)
    },
    asyncUpdatePerms(context, perms) {
      context.commit('updatePerms', perms)
    },
    asyncUpdateMenuList(context, menuList) {
      context.commit('updateMenuList', menuList)
    },
    asyncUpdateTabList(context, tabList) {
      context.commit('updateTabList', tabList)
    },
    asyncUpdateCurrentTab(context, currentTab) {
      context.commit('updateCurrentTab', currentTab)
    },
    asyncUpdateMainPagePath(context, mainPagePath) {
      context.commit('updateMainPagePath', mainPagePath)
    },
    asyncUpdateRouterParams(context, routerParams) {
      context.commit('updateRouterParams', routerParams)
    }
  }
}

export default user
